export enum CheckboxVariant {
  Default = "Default",
  Dashed = "Dashed",
}
